// extracted by mini-css-extract-plugin
module.exports = {"host":"users-compare_host__RnfCD","title":"users-compare_title__pUfBj","icon":"users-compare_icon__Zsj4v","description":"users-compare_description__onj3_"};